var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMonthEndClose(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 23,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.013 19.57v2.52l-3.038-2.016-3.037 2.016v-2.52H4.43c-.94 0-1.84-.371-2.505-1.033a3.519 3.519 0 0 1-1.038-2.494V3.445c0-.802.32-1.57.89-2.138A3.045 3.045 0 0 1 3.924.422H18.1c.269 0 .526.106.716.295.19.19.297.445.297.713v17.133A1.015 1.015 0 0 1 18.1 19.57h-7.088zm-6.075-2.015v-2.016h6.075v2.016h6.075V14.53H4.43c-.402 0-.789.16-1.073.443a1.508 1.508 0 0 0 0 2.138c.284.283.67.443 1.073.443h.507zm0-14.11v2.016h2.025V3.445H4.938zm0 3.024v2.015h2.025V6.47H4.938zm0 3.023v2.016h2.025V9.492H4.938z",
    fill: "#212134"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMonthEndClose);
export default __webpack_public_path__ + "static/media/month-end-close.3af48844f368ba106730e5f6fbfe06f4.svg";
export { ForwardRef as ReactComponent };